// ISO_DATE_V1: календарные даты без участия UTC.
//
// По коду был рассыпан приём `new Date(...).toISOString().split('T')[0]`. Он
// переводит момент времени в UTC — и для часовых поясов восточнее Гринвича даёт
// не ту календарную дату:
//
//   new Date('2026-08-20T00:00:00')      // локальная полночь 20 августа
//   .toISOString()                        // '2026-08-19T21:00:00.000Z' (UTC+3)
//   .split('T')[0]                        // '2026-08-19'  ← днём раньше
//
// Из-за этого в окне «Заполнить из меню» дни меню были подписаны на день назад:
// человек выбирал приёмы под заголовком «20 августа», а записи ложились на 21-е.
// Тем же приёмом `today()` между полуночью и тремя часами ночи возвращал вчера.
//
// Здесь дата — это календарь, а не момент: ни разбор, ни сборка через UTC не идут.

/** Собрать YYYY-MM-DD из компонентов. */
const pad = (n: number): string => String(n).padStart(2, '0');

/** Сегодня по местному календарю. */
export const todayIso = (): string => dateToIso(new Date());

/** Локальная дата объекта Date → YYYY-MM-DD. */
export const dateToIso = (d: Date): string =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

/**
 * Сдвиг календарной даты на N дней. Работает со строкой как с календарём:
 * переход через месяц и год берёт на себя Date, но час и пояс в расчёт не входят.
 * Некорректная строка возвращается как есть — подставлять «сегодня» вместо
 * непонятного ввода значит молча увести пользователя не на тот день.
 */
export const addDaysIso = (iso: string, days: number): string => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return iso;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  if (Number.isNaN(d.getTime())) return iso;
  d.setDate(d.getDate() + days);
  return dateToIso(d);
};
